export default __webpack_public_path__ + "aaca68677cf794c846d2d69cd49c71e5.mp3";